import { useTranslation } from 'react-i18next'

import { FormModal, formValidationSchemaNoChanged } from '../../Form'
import {
  DocFlowEditTypeFields,
  getEditTypeFieldsInitialValues,
} from '../DocFlowEditTypeFields'

import { getDocFlowChangeTypeValue } from './DocFlowChangeTypeModal.utils'

function DocFlowChangeTypeModal({
  isSingleItemChanging,
  type,
  onCloseModal,
  onSubmit,
}) {
  const { t } = useTranslation()

  const initialValues = getEditTypeFieldsInitialValues(type, t)

  const validationSchema = isSingleItemChanging
    ? formValidationSchemaNoChanged({ initialValues })
    : undefined

  return (
    <FormModal
      Fields={DocFlowEditTypeFields}
      formBodyProps={{
        withNotifications: true,
      }}
      formTitle='DocumentStapling.ModalEditDocumentTypeTitleKey'
      getPayload={getDocFlowChangeTypeValue}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onCloseModal}
      onSubmit={onSubmit}
    />
  )
}

export default DocFlowChangeTypeModal
